import clsx from 'clsx';

export default function Table({rows}: any) {
  return (
    <div>
      {rows.map(({cells}: any, i: number) => (
        <div
          style={{gridTemplateColumns: `repeat(${cells.length}, 1fr)`}}
          key={i}
          className={clsx([
            'grid border-b border-dark-grey/30',
            i === 0 && 'border-t font-bold',
          ])}
        >
          {cells.map((text: string, i: number) => (
            <div
              key={i}
              className={clsx([
                'border-r border-dark-grey/30 p-1 text-xs md:p-4 md:text-lg',
                i === 0 && 'border-l',
              ])}
            >
              {text}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
